const ACTIVITY_DISPLAY_TIME_ZONE = "America/Toronto";

function normalizeTimestamp(value) {
  if (typeof value !== "string") {
    return "";
  }
  return value.trim();
}

function defaultGetActivityTimestamp(item) {
  if (!item || typeof item !== "object") {
    return "";
  }
  return item.occurred_at || item.created_at || item.recordedAt || item.recorded_at || "";
}

export function resolveCaptureActivityDateKey(value) {
  const normalizedValue = normalizeTimestamp(value);
  if (!normalizedValue) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(normalizedValue)) {
    return normalizedValue;
  }

  const parsedDate = new Date(normalizedValue);
  if (Number.isNaN(parsedDate.getTime())) {
    const dateOnly = normalizedValue.slice(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(dateOnly) ? dateOnly : "";
  }

  return new Intl.DateTimeFormat("en-CA", {
    day: "2-digit",
    month: "2-digit",
    timeZone: ACTIVITY_DISPLAY_TIME_ZONE,
    year: "numeric",
  }).format(parsedDate);
}

export function formatCaptureActivityGroupLabel(activityDate) {
  const normalizedDate = resolveCaptureActivityDateKey(activityDate);
  if (!normalizedDate) {
    return "Journée non précisée";
  }

  const parsedDate = new Date(`${normalizedDate}T12:00:00`);
  if (Number.isNaN(parsedDate.getTime())) {
    return normalizedDate;
  }

  return new Intl.DateTimeFormat("fr-CA", {
    day: "numeric",
    month: "long",
  }).format(parsedDate);
}

export function groupCaptureItemsByActivityDate(items = [], getActivityTimestamp) {
  const resolveActivityTimestamp = typeof getActivityTimestamp === "function"
    ? getActivityTimestamp
    : defaultGetActivityTimestamp;
  const groupsByDate = new Map();

  (Array.isArray(items) ? items : []).forEach((item) => {
    const activityDate = resolveCaptureActivityDateKey(resolveActivityTimestamp(item));
    const existingGroup = groupsByDate.get(activityDate);
    if (existingGroup) {
      existingGroup.items.push(item);
      return;
    }
    groupsByDate.set(activityDate, {
      activityDate,
      items: [item],
    });
  });

  return Array.from(groupsByDate.values()).sort((left, right) => {
    if (!left.activityDate && !right.activityDate) {
      return 0;
    }
    if (!left.activityDate) {
      return 1;
    }
    if (!right.activityDate) {
      return -1;
    }
    return right.activityDate.localeCompare(left.activityDate);
  });
}
